import { createTestingPinia } from '@pinia/testing';
import { shallowMount } from '@vue/test-utils';
import { setActivePinia } from 'pinia';

import Component from './ProcessShippingClaims.vue';

let wrapper;

describe('ProcessShippingClaims', () => {
  beforeEach(() => {
    setActivePinia(
      createTestingPinia({
        initialState: {
          orders: {
            currentOrder: {
              existingClaims: [],
            },
          },
        },
      }),
    );
    wrapper = shallowMount(Component);
  });

  test('render', () => {
    expect(wrapper.isVisible()).toBe(true);
  });
});
